import { calculateCalendarInitialDates, getNextPageParam, getPreviousPageParam } from './helpers';
import { fetchOptions, generateCalendarDatesEndpoint, queryKeyFactory } from '@alluradirect/react';

import { httpsUrl } from 'config/url';
import { useInfiniteQuery } from 'react-query';

const { defaultEnd, defaultStart } = calculateCalendarInitialDates();

const queryFn = async ({ pageParam = { startDate: defaultStart, endDate: defaultEnd } }, propertyId: number) => {
  const { startDate, endDate } = pageParam;
  const endpoint = `${httpsUrl()}${generateCalendarDatesEndpoint({ propertyId, startDate, endDate })}`;

  try {
    const response = await fetch(endpoint, {
      ...fetchOptions,
    });

    if (!response.ok) {
      throw new Error('You Have an Error ' + response.url);
    }

    const data = await response.json();

    return { startDate, endDate, dates: data.DATA.DATES };
  } catch (e: unknown) {
    throw new Error(e as any);
  }
};

export const propertyCalendarDatesQueryKeyFactory = queryKeyFactory('calendar-dates');

export const usePropertyCalendarDates = (propertyId: number, minSearchDate: string, enabled = true) => {
  const queryKey = propertyCalendarDatesQueryKeyFactory.detail(String(propertyId));

  return useInfiniteQuery<any, Error>({
    queryFn: pageParam => queryFn(pageParam, propertyId),
    queryKey,
    getPreviousPageParam: firstPage => getPreviousPageParam(firstPage, minSearchDate),
    getNextPageParam,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    cacheTime: Infinity,
    useErrorBoundary: true,
    enabled,
  });
};
